import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

type WidgetSwitchProps = {
    id: string;
    label: string;
    isChecked: boolean;
    handleOnCheckedChange: (checked: boolean) => void;
};

const WidgetSwitch = ({
    id,
    label,
    isChecked,
    handleOnCheckedChange,
}: WidgetSwitchProps) => (
    <div className="flex w-full items-center space-x-2 bg-surface-primary p-4">
        <Switch
            checked={isChecked}
            id={id}
            onCheckedChange={handleOnCheckedChange}
        />
        <Label htmlFor={id}>{label}</Label>
    </div>
);

export default WidgetSwitch;
